module.exports = __webpack_public_path__ + "static/media/south_africa.f341ba1c.png";